/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import Model from '@tripian/model';
import FormTemplateCompanion from '../FormTemplate/FormTemplateCompanion/FormTemplateCompanion';
import CloseIconButton from '../base/Button/Icons/CloseIconButton/CloseIconButton';
import Button from '../base/Button/Button';
import CompanionModalMode from './CompanionModalMode';
import classes from './CompanionModal.scss';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (companion: Model.Companion) => void;
  initialData?: Model.Companion | null;
  mode?: CompanionModalMode;
  questions: Array<Model.Question>;
  t: (value: Model.TranslationKey) => string;
}

const CompanionModal: React.FC<Props> = ({ isOpen, onClose, onSubmit, initialData = null, mode = CompanionModalMode.CREATE, questions, t }) => {
  const [isChanged, setIsChanged] = useState(false);
  const [formData, setFormData] = useState<Model.Companion>({
    id: 0,
    title: 'Family member',
    name: '',
    age: 0,
    answers: [],
    memberOfTrip: false,
  });
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);

  useEffect(() => {
    if (initialData) {
      const isDifferent = JSON.stringify(initialData) !== JSON.stringify(formData);
      setIsChanged(isDifferent);
    } else {
      // 'create' modunda form değiştikçe buton aktif olmalı
      setIsChanged(!!formData.name.trim() && !!formData.age);
    }
  }, [formData, initialData]);

  useEffect(() => {
    if (isOpen) {
      setIsAnimating(true);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  const handleAnimationEnd = () => {
    if (!isOpen) {
      setIsAnimating(false);
    }
  };

  if (!isOpen && !isAnimating) return null;

  const handleSubmit = () => {
    onSubmit(formData);
    setFormData({
      id: 0,
      title: 'Family member',
      name: '',
      age: 0,
      answers: [],
      memberOfTrip: false,
    });
    onClose();
  };

  const content = (
    <div className={`${classes.modal} ${isOpen ? classes.visible : classes.hidden}`} onTransitionEnd={handleAnimationEnd}>
      <div className={`${classes.content} ${isOpen ? classes.visible : ''}`}>
        <form>
          <div className={classes.header}>
            <div className={classes.headerContent}>
              <div className={classes.title}>{mode === CompanionModalMode.CREATE ? t('create_companion_modal_title') : t('update_companion_modal_title')}</div>
              <CloseIconButton className="w-6 h-6" fill="#2B2B33" clicked={onClose} />
            </div>
            <FormTemplateCompanion questions={questions} userCompanion={formData} callbackFormTemplateCompanion={setFormData} t={t} />
            <div className={classes.footer}>
              <Button className="w-full" text={mode === CompanionModalMode.CREATE ? t('add_companion') : t('update_companion')} color="primary" disabled={!isChanged || !formData.name.trim() || !formData.age} onClick={handleSubmit} />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
  return createPortal(content, document.body);
};

export default CompanionModal;
